<mg-points-leaderboard [isInlineVersion]="true"></mg-points-leaderboard>
